function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ProjectFeatureFlag, ReportName, UserFeatureFlag } from 'common/report/constants';
import { ChartType } from 'common/types/reports/bookmark';
import { FlowsResponse } from 'common/report/funnels/models/api-types';
import { FlowsBookmark } from 'common/report/flows/models/types';
import { ReportVisualization } from 'common/report/report-manager/visualization';
import { BaseQueryErrorType } from 'common/report/types';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { ChartHeaderUpdateDetail } from 'common/widgets/chart-header';
import { ChartHeaderAttrs } from 'common/widgets/chart-header/types';
import { getAdvancedQueryOptionItems, getAlignmentToggleDisabledText, getAnchorPositionForChartType, handleFlowsPopoverAction, updateReportAlignment, updateReportFromAdvancedSettings, updateReportHiddenEvents } from 'common/report/flows/util';
import { FlowsReport } from 'common/report/flows/models/report';
import { emitTrackEvent } from 'common/util/dom';
import { DateRange } from 'common/widgets/date-range-picker/models/date-range';
import { FullLengthDateRange } from 'common/widgets/date-range-picker/models/full-length-date-range';
import { BookmarkUpdateDetail } from 'common/report/report-manager/types';
import { CommonChartTypeToFlowsChartType, FlowsChartTypeToCommonChartType } from 'common/report/flows/util/bookmark-overrides';
import { AlignmentOptions } from 'common/widgets/sankey-chart/models/types';
import { SelectEl } from 'common/components/select';
import { QueryBlockEl } from 'common/query-builder/query-block/panel';
import { QueryReason } from 'common/report/util/query-tracking/types';
import { MenuType } from 'common/query-builder/query-block/types';
import { SelectorType } from 'common/query-builder/query-block/constants';
import { FlowsChartDisplayEl, PopoverActionEvent } from './charts/chart-display';
import { FlowsAdvancedSettingsEl } from './advanced-settings';
import { FlowsCardinalityControlEl } from './cardinality-control';
export class FlowsVisualization extends ReportVisualization<FlowsBookmark, FlowsResponse, BaseQueryErrorType> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "reportName", ReportName.Flows);
    _defineProperty(this, "sankeyScrollOffset", 0);
  }
  chartDisplay() {
    return <FlowsChartDisplayEl attrs={{
      loaded: true,
      'sankey-scroll-offset': this.sankeyScrollOffset,
      elref: "chartDisplay"
    }} props={{
      bookmarkParams: this.bookmarkParams,
      queryResults: this.results,
      customEvents: this.customEvents
    }} on={{
      update: ev => this.dispatchUpdate({
        params: _objectSpread(_objectSpread({}, this.bookmarkParams), ev.detail.delta)
      }),
      updateScrollOffset: ev => this.sankeyScrollOffset = ev.detail,
      popoverAction: ev => this.handlePopoverAction(ev)
    }} />;
  }
  headerChildrenTemplate() {
    var _this$project, _this$attr, _this$attr2, _this$project2, _this$userDetails;
    const report = this.getReportModel();
    const alignmentToggleAllowed = (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.hasFeatureFlag(ProjectFeatureFlag.FlowsAlignmentToggle);
    const alignmentDisabledText = getAlignmentToggleDisabledText(report);
    return <>
        <div sel='.chart-controls' attrs={{
        slot: "chart-controls"
      }}>
          {alignmentToggleAllowed && <SelectEl sel='.alignment-selector' attrs={{
          disabled: !!alignmentDisabledText,
          icon: {
            leftIcon: AlignmentOptions[report.getOverallAlignment()].icon
          },
          'icon-only': true,
          'show-icon-only-down-caret': true,
          'menu-width': 200
        }} params={{
          sections: [{
            items: Object.values(AlignmentOptions).map(option => _objectSpread(_objectSpread({}, option), {}, {
              isSelected: option.value === report.getOverallAlignment()
            }))
          }],
          tooltip: {
            text: alignmentDisabledText
          }
        }} on={{
          change: ev => {
            const updatedReport = updateReportAlignment(report, ev.detail.item.value);
            this.dispatchUpdate({
              params: updatedReport.generateBookmark()
            });
          }
        }} />}
          <QueryBlockEl className='hidden-events' type={MenuType.Events} excludeCustomEvents multiple projectId={(_this$attr = this.attr("project-id")) !== null && _this$attr !== void 0 ? _this$attr : undefined} selected={report.visibleEvents.length ? report.visibleEvents : report.hiddenEvents} inverted={report.visibleEvents.length > 0} selectorIcon='eye-hide' selectorType={SelectorType.Button} dataGroupId={report.dataGroupId || ""} workspaceId={(_this$attr2 = this.attr("workspace-id")) !== null && _this$attr2 !== void 0 ? _this$attr2 : undefined} onSelect={(detail: TODO) => {
          const updatedReport = updateReportHiddenEvents(report, detail);
          this.dispatchUpdate({
            params: updatedReport.generateBookmark()
          });
        }} />
          <FlowsCardinalityControlEl attrs={{
          cardinality: report.cardinality
        }} on={{
          change: ev => {
            report.update({
              cardinality: ev.detail
            });
            this.dispatchUpdate({
              params: report.generateBookmark()
            });
          }
        }} />
        </div>

        <div sel='.advanced-controls' attrs={{
        slot: "advanced-chart-controls"
      }}>
          <FlowsAdvancedSettingsEl attrs={{
          items: getAdvancedQueryOptionItems({
            report,
            percentilesEnabled: (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.hasFeatureFlag(ProjectFeatureFlag.FlowsTimePercentiles),
            isDev: (_this$userDetails = this.userDetails) === null || _this$userDetails === void 0 ? void 0 : _this$userDetails.featureFlags.has(UserFeatureFlag.Dev)
          })
        }} on={{
          change: ev => {
            const updatedReport = updateReportFromAdvancedSettings(report, ev.detail);
            this.dispatchUpdate({
              params: updatedReport.generateBookmark()
            });
          }
        }} />
        </div>
      </>;
  }
  handlePopoverAction(ev: PopoverActionEvent) {
    handleFlowsPopoverAction({
      detail: ev.detail,
      customEvents: this.customEvents,
      report: this.getReportModel(),
      updateFn: params => this.updateBookmarkParamsFromModel(params),
      trackFn: (eventName, props) => emitTrackEvent(this, {
        eventName,
        props
      }),
      updateUserSidebarContextFn: (isOpen: boolean) => this.getContext("reportLayoutManager").updateIsUserSidebarOpen(isOpen),
      i18n: this.getContext("i18n")
    });
  }
  updateBookmarkParamsFromModel(modelParams: Partial<FlowsReport>) {
    const report = this.getReportModel();
    report.update(modelParams);
    this.dispatchUpdate({
      params: report.generateBookmark()
    });
  }
  getReportModel() {
    return FlowsReport.fromBookmarkParams(this.bookmarkParams);
  }
  reportSpecificHeaderAttrs(): Partial<ChartHeaderAttrs> {
    return {
      'chart-types': [ChartType.Flows, ChartType.FlowsTopPaths],
      'selected-chart-type': FlowsChartTypeToCommonChartType[this.bookmarkParams.chartType],
      'date-range': DateRange.fromBookmarkFormat(this.bookmarkParams.date_range).getAttributes(),
      'show-date-range-selector': true,
      'track-name': "flows"
    };
  }
  bookmarkUpdateFromHeaderUpdate(update: ChartHeaderUpdateDetail): BookmarkUpdateDetail<FlowsBookmark> {
    const bookmarkParamUpdates: Partial<FlowsBookmark> = {};
    if (update.delta.dateRange) {
      bookmarkParamUpdates.date_range = new FullLengthDateRange(update.delta.dateRange).getBookmarkFormat();
    }
    let hasChangedChartType = false;
    if (update.delta.chartType) {
      bookmarkParamUpdates.chartType = CommonChartTypeToFlowsChartType[update.delta.chartType];
      hasChangedChartType = this.bookmarkParams.chartType !== bookmarkParamUpdates.chartType;
      bookmarkParamUpdates.anchorPosition = getAnchorPositionForChartType(update.delta.chartType);
    }
    return {
      params: _objectSpread(_objectSpread({}, this.bookmarkParams), bookmarkParamUpdates),
      queryReason: QueryReason.QbOtherUpdate,
      hasChangedChartType,
      requery: true
    };
  }
}
export const FlowsVisualizationEl = defineAndMakeJsxFactory("flows-visualization", FlowsVisualization);
export const FlowsVisualizationReact = panel2react("flows-visualization", FlowsVisualization);